"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var CashPrices_1 = require("../../prices/cash/CashPrices");
var CarDetailsPricesWithFinance_1 = require("./CarDetailsPricesWithFinance");
var carDetailsPricesWithFinanceStyles_1 = require("./carDetailsPricesWithFinanceStyles");
var ReservationLabel_1 = require("../../prices/reservation/ReservationLabel");
var CarDetailsPrices = function (_a) {
    var primary = _a.primary, secondary = _a.secondary, isMultiCurrency = _a.isMultiCurrency, financeDetails = _a.financeDetails, taxLabel = _a.taxLabel;
    var style = carDetailsPricesWithFinanceStyles_1.default();
    var hideReservationLabel = core_1.useTheme().checkoutLite.summary.hideReservationLabel;
    if (financeDetails) {
        return (<CarDetailsPricesWithFinance_1.default primary={primary} secondary={secondary} isMultiCurrency={isMultiCurrency} financeDetails={financeDetails} taxLabel={taxLabel}/>);
    }
    return (<>
      <core_1.Box className={style.wrapper}>
        <CashPrices_1.default primaryPrice={primary} secondaryPrice={secondary} isMultiCurrency={isMultiCurrency} taxLabel={taxLabel} dataTest="summary:text:car_price"/>
      </core_1.Box>
      {!hideReservationLabel && <ReservationLabel_1.default />}
    </>);
};
exports.default = CarDetailsPrices;
